module.exports = __webpack_public_path__ + "img/C-751-760.4c28be89.svg";